import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { AddressDataState } from "../../../features/view/private/profilePage/components/ProfilePageTypes";
import {
  addAddress,
  deleteAddress,
  fetchAddressList,
  getAddressDetails,
  updateAddress,
} from "./AddressApi";

const initialState: AddressDataState = {
  addressList: { data: [], loader: false },
  addAddressloader: false,
  updateAddressloader: false,
  addressDetailLoader: false,
};

export const getAddressListAsync = createAsyncThunk(
  "address/get/list",
  async () => {
    const response = await fetchAddressList();
    return response;
  }
);
export const addAddressAsync = createAsyncThunk(
  "address/add",
  async ({
    payload,
    modalType,
    addressId,
  }: {
    payload: any;
    modalType: string;
    addressId?: any;
  }) => {
    const response = await addAddress(payload, modalType, addressId);
    return response;
  }
);
export const updateAddressAsync = createAsyncThunk(
  "address/update",
  async (payload: any) => {
    const response = await updateAddress(payload);
    return response;
  }
);
export const getAddressDetailsAsync = createAsyncThunk(
  "address/details",
  async (payload: any) => {
    const response = await getAddressDetails(payload);
    return response;
  }
);
export const deleteAddressAsync = createAsyncThunk(
  "address/delete",
  async (payload: any) => {
    const response = await deleteAddress(payload);
    return response;
  }
);
export const AddressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAddressListAsync.pending, (state) => {
        state.addressList.loader = true;
      })
      .addCase(getAddressListAsync.fulfilled, (state, action: any) => {
        state.addressList.loader = false;
        state.addressList.data = action?.payload?.data?.data || [];
      })
      .addCase(getAddressListAsync.rejected, (state) => {
        state.addressList.loader = false;
      })
      .addCase(addAddressAsync.pending, (state) => {
        state.addAddressloader = true;
      })
      .addCase(addAddressAsync.fulfilled, (state, action: any) => {
        state.addAddressloader = false;
      })
      .addCase(addAddressAsync.rejected, (state) => {
        state.addAddressloader = false;
      })
      .addCase(updateAddressAsync.pending, (state) => {
        state.updateAddressloader = true;
      })
      .addCase(updateAddressAsync.fulfilled, (state, action: any) => {
        state.updateAddressloader = false;
      })
      .addCase(updateAddressAsync.rejected, (state) => {
        state.updateAddressloader = false;
      })
      .addCase(getAddressDetailsAsync.pending, (state) => {
        state.addressDetailLoader = true;
      })
      .addCase(getAddressDetailsAsync.fulfilled, (state, action: any) => {
        state.addressDetailLoader = false;
      })
      .addCase(getAddressDetailsAsync.rejected, (state) => {
        state.addressDetailLoader = false;
      });
  },
});

export default AddressSlice.reducer;
